<template>
  <div id="employeeList" class="contenedor">
    <Sidebar></Sidebar>
    <loader :show="show" />
    <v-container fluid class="base text-center ma-0 px-0 pt-3 pb-0">
      <v-row no-gutters class="titulo">Administración de Empleados</v-row
      ><br /><br />
      <v-row no-gutters class="mt-4">
        <v-col
          cols="12"
          lg="6"
          md="6"
          sm="6"
          xs="6"
          class="ml-12"
          align-self="end"
        >
          <v-card-title style="width: 90% !important" class="ml-12">
            <label for="enterprise" class="ml-5 mr-2" style="font-size: 0.7em"
              >Empresa Pagadora</label
            >
            <select
              name="enterprise"
              id="enterprise"
              v-model="enterprise"
              @change="obtenerEmpresa()"
              class="selectEdit"
              style="
                font-size: 0.6em;
                padding-left: 5px;
                border-radius: 5px;
                height: 35px;
              "
            >
              <option selected disabled value="0">Selecciona Empresa</option>
              <option
                v-for="enterprise in enterprises"
                :key="enterprise.id"
                v-bind:value="enterprise.id"
              >
                {{ enterprise.razonSocial }}
              </option>
            </select>
          </v-card-title>
        </v-col>
        <v-col cols="12" lg="6" md="6" sm="6" xs="6" class="ml-n12">
          <v-card-title style="width: 90% !important">
            <router-link to="/addEmployee" id="nuevoEmpleado">
              <button class="boton mr-5" style="float: none; font-size: 0.7em">
                <span class="px-2 pt-3 ma-0 fa-1x">
                  <font-awesome-icon
                    icon="calendar-alt"
                  ></font-awesome-icon> </span
                >Alta Empleado
              </button>
            </router-link>
            <v-text-field
              style="margin-right: 17%"
              v-model="search"
              append-icon="search"
              label="Buscador"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
        </v-col>
      </v-row>
      <v-row no-gutters class="datos pa-0" style="height: auto !important">
        <v-card style="width: 100%; background: rgb(199, 195, 199) !important">
          <v-data-table
            :headers="headers"
            :items="employees"
            :search="search"
            class="elevation-2 text--dark table-striped"
            :items-per-page="5"
            :no-results-text="'No se encontraron incidencias'"
            :no-data-text="'No hay datos'"
            :footer-props="{
              'items-per-page-text': 'Empleados por página',
              'items-per-page': [5, 10, 15],
              'items-per-page-all-text': 'Todos',
              'items-per-page-options': [5, 10],
              'loading-text': 'Obteniendo datos... Por favor espere',
              'no-data-text': 'No hay datos...',
              'no-results-text': 'No se encontraron incidencias',
            }"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.id"
                  :class="{ selectedRow: item === selectedItem }"
                >
                  <td class="text-sm-center">{{ item.id }}</td>
                  <td class="text-sm-center">
                    {{ item.nombre + " " + item.apellidoPaterno }}
                  </td>
                  <td class="text-sm-center">{{ item.rfc }}</td>
                  <td class="text-sm-center">{{ item.area.nombreArea }}</td>
                  <td class="text-sm-center">
                    {{
                      item.sucursal != null ? item.sucursal.nombreSucursal : ""
                    }}
                  </td>
                  <td class="justify-center layout px-0">
                    <v-icon
                      color="#717171"
                      small
                      class="mr-6"
                      @click="editItem(item)"
                      >fa-edit</v-icon
                    >
                    <v-icon
                      color="#717171"
                      small
                      class="mr-6"
                      @click="viewItem(item)"
                      >fa-eye</v-icon
                    >
                    <v-icon color="red" small @click="temporal(item)"
                      >fa-trash-alt</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
          <v-card-actions class="justify-center">
            <router-link to="/cfdi">
              <button
                class="boton mr-5"
                style="float: none !important; font-size: 1em"
              >
                Datos CFDI
              </button>
            </router-link>
            <router-link to="/catalogueHolidays">
              <button
                class="boton"
                style="float: none !important; font-size: 1em"
              >
                Siguiente
              </button>
            </router-link>
          </v-card-actions>
        </v-card>
      </v-row>
    </v-container>

    <!--Aceptación de acciones-->
    <v-dialog v-model="advice" width="400">
      <v-card>
        <v-card-title class="red white--text">
          <span class="headline">Aviso</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 style="text-align: center">{{ respuesta }}</h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="red" text @click="advice = false">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="deleteItem()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Confirmación de datos-->
    <v-dialog v-model="confirmation" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Empleado</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-lg-center text-sm-center text-md-center">
            {{ respuesta }}
          </h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="confirmation = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--DIALOG DE DATOS-->
    <v-dialog v-model="dialog" scrollable max-width="410px">
      <v-card>
        <v-card-title class="orange white--text"
          >Información de Empleado</v-card-title
        >
        <v-card-text style="height: 300px" id="info">
          <div class="form-group mt-5">
            <label>Numero de Empleado:</label>
            {{ employeeNumber }}
          </div>
          <div class="form-group">
            <label>Nombre:</label>
            {{ name }}
          </div>
          <div class="form-group">
            <label>Primer Apellido:</label>
            {{ surname }}
          </div>
          <div class="form-group">
            <label>Segundo Apellido:</label>
            {{ lastName }}
          </div>
          <div class="form-group">
            <label>Fecha de Nacimiento:</label>
            {{ date }}
          </div>
          <div class="form-group">
            <label>RFC:</label>
            {{ rfc }}
          </div>
          <div class="form-group">
            <label>CURP:</label>
            {{ curp }}
          </div>
          <div class="form-group">
            <label>NSS:</label>
            {{ imss }}
          </div>
          <div class="form-group">
            <label>Puesto:</label>
            {{ job }}
          </div>
          <div class="form-group">
            <label>Area:</label>
            {{ area }}
          </div>
          <div class="form-group">
            <label>Empresa:</label>
            {{ enterprise }}
          </div>
          <div class="form-group">
            <label>Fecha de Admision:</label>
            {{ dateAdmission }}
          </div>
          <div class="form-group">
            <label>Antiguedad:</label>
            {{ labor }} año(s)
          </div>
          <div class="form-group">
            <label>Tipo de Contrato:</label>
            {{ contract }}
          </div>
          <div class="form-group">
            <label>Tipo de Jornada:</label>
            {{ day }}
          </div>
          <div class="form-group">
            <label>Riesgo de Trabajo:</label>
            {{ risk }}
          </div>
          <div class="form-group">
            <label>Sindicalizado:</label>
            {{ union }}
          </div>
          <div class="form-group">
            <label>Regimen:</label>
            {{ regime }}
          </div>
          <div class="form-group">
            <label>Periodicidad de Pago:</label>
            {{ periodicity }}
          </div>
          <div class="form-group">
            <label>Banco:</label>
            {{ bank }}
          </div>
          <div class="form-group">
            <label>Cuenta:</label>
            {{ count }}
          </div>
          <div class="form-group">
            <label>Clave interbancaria:</label>
            {{ key }}
          </div>
          <div class="form-group">
            <label>Anticipo de Nomina:</label>
            {{ nomina }}
          </div>
          <div class="form-group">
            <label>Sueldo:</label>
            {{ sueldo }}
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import Loader from "@/components/Loader";
export default {
  components: {
    Sidebar,
    Loader,
  },
  data() {
    return {
      stepn: "6-N",
      search: "",
      show: false,
      dialog: false,
      selectedItem: null,
      headers: [
        {
          text: "N° Empleado",
          align: "center",
          value: "id",
        },
        {
          text: "Nombre",
          align: "center",
          value: "nombre",
        },
        {
          text: "RFC",
          align: "center",
          value: "rfc",
        },
        {
          text: "Area/Departamento",
          align: "center",
          value: "area.nombreArea",
        },
        {
          text: "Sucursal",
          align: "center",
          value: "sucursal.nombreSucursal",
        },
        {
          text: "Editar  /   Ver  / Eliminar",
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],
      employees: [],
      employeeNumber: 0,
      name: "",
      surname: "",
      lastName: "",
      date: "",
      rfc: "",
      curp: "",
      imss: "",
      job: "",
      area: "",
      enterprise: 0,
      dateAdmission: "",
      labor: "",
      contract: 0,
      day: 0,
      risk: 0,
      union: 0,
      regime: 0,
      periodicity: 0,
      bank: 0,
      count: "",
      key: "",
      nomina: 0,
      sueldo: 0,
      enterprises: [],
      respuesta: "",
      advice: false,
      id: "",
      confirmation: false,
      edit: false,
      vacio: false,
    };
  },
  methods: {
    nombre() {
      localStorage.stepn = this.stepn;
    },
    listar() {
      this.show = true;
      axios
        .get(Server + "/empresas")
        .then((response) => {
          this.enterprises = response.data;
          this.show = false;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },

    format_date(fecha1, fecha2) {
      //console.log("fecha pasada" + fecha1);
      var aux = fecha1.substr(0, 10);
      //console.log("fecha obtenida" + aux);
      var aux2 = fecha2.substr(0, 10);
      this.date = aux;
      this.dateAdmission = aux2;
      return true;
    },
    editItem(item) {
      //console.log("Ingreso a editar" + item.id);
      localStorage.employeeNumber = item.id;
      this.$router.push("/editEmployee");
    },
    obtenerEmpresa() {
      this.employees = [];
      this.show = true;
      axios
        .get(
          Server + "/empleados/por-empresa/" + this.enterprise + "/?estatus=0"
        )
        .then((response) => {
          this.show = false;
          this.employees = response.data;
        })
        .catch((e) => {
          this.show = false;
          console.log(e);
        });
    },
    viewItem(item) {
      console.log("Ingreso a detalle", item);
      console.log(item);
      this.employeeNumber = item.id;
      this.name = item.nombre;
      this.lastName = item.apellidoPaterno;
      this.surname = item.apellidoMaterno;
      this.date = item.fechaNacimiento;
      this.rfc = item.rfc;
      this.curp = item.curp;
      this.imss = item.nss;
      this.job = item.puesto.nombrePuesto;
      this.area = item.area.nombreArea;
      this.enterprise = item.empresa.razonSocial;
      this.dateAdmission = item.fechaAdmision;
      if (item.cfdiEmpleado == null) {
        this.labor = "0";
        this.day = "Desconocida";
        this.risk = "N/A";
        this.union = "N/A";
        this.regime = "Desconocido";
        this.periodicity = "Desconocida";
        this.contract = "Desconocido";
      } else {
        this.labor = item.cfdiEmpleado.antiguedad;
        this.contract = item.cfdiEmpleado.contrato.tipoContrato;
        this.day = item.cfdiEmpleado.jornada.nombreJornada;
        this.risk = item.cfdiEmpleado.riesgo.nombreRiesgo;
        this.union = item.cfdiEmpleado.sindicalizado;
        this.regime = item.cfdiEmpleado.regimen.nombreRegimen;
        this.periodicity =
          item.cfdiEmpleado.periodicidadPago.nombrePeriodicidad;
      }
      if (this.union === false) {
        this.union = "No";
      } else {
        this.union = "Si";
      }
      if (item.datosBancoEmpleado == null) {
        this.bank = "Sin dato";
        this.count = "Sin dato";
        this.key = "Sin dato";
        this.nomina = "Sin dato";
      } else {
        this.bank = item.datosBancoEmpleado.banco.nombreCorto;
        this.count = item.datosBancoEmpleado.cuenta;
        this.key = item.datosBancoEmpleado.cuentaClabe;
        this.nomina = item.datosBancoEmpleado.anticipoNomina;
      }
      this.sueldo = item.sueldo;
      if (this.nomina === false) {
        this.nomina = "No";
      } else {
        this.nomina = "Si";
      }
      this.format_date(this.date, this.dateAdmission);
      this.dialog = true;
    },
  },
  created() {
    this.nombre();
    this.listar();
  },
};
</script>
